/* eslint-disable react/prop-types */
import React, { createContext, useState, useEffect } from 'react';
import useGetLoggedInUser from '../Hooks/LoggedInUser/useGetLoggedInUser';
import useCompanyType from '../Hooks/CompanyData/useCompanyType';
import useGetAuthUser from '../Hooks/LoggedInUser/useGetAuthUser';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Helper function to safely parse JSON from sessionStorage
  const getSessionData = (key) => {
    try {
      const data = sessionStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error(`Error parsing ${key} from sessionStorage:`, error);
      return null;
    }
  };

  // Initialize state from sessionStorage to handle page refreshes
  const [appState, setAppState] = useState({
    user: getSessionData('user'),
    companyType: getSessionData('companyType'),
    authUser: getSessionData('authUser'),
  });

  // User
  const { data: userData, isLoading: isLoadingUser } = useGetLoggedInUser();
  useEffect(() => {
    if (userData) {
      sessionStorage.setItem('user', JSON.stringify(userData?.data));
      setAppState((prev) => ({ ...prev, user: userData?.data }));
    }
  }, [userData]);

  // Company
  const { data: companyTypeData, isLoading: isLoadingCompanyType } = useCompanyType(userData?.data?.companyType);
  useEffect(() => {
    if (companyTypeData) {
      sessionStorage.setItem('companyType', JSON.stringify(companyTypeData?.data));
      setAppState((prev) => ({ ...prev, companyType: companyTypeData?.data }));
    }
  }, [companyTypeData]);

  const { data: authUserData, isLoading: isLoadingAuthUser } = useGetAuthUser();

  useEffect(() => {
    if (authUserData) {
      sessionStorage.setItem('authUser', JSON.stringify(authUserData?.data));
      setAppState((prev) => ({ ...prev, authUser: authUserData?.data }));
    }
  }, [authUserData]);

  // Track overall loading state
  const isLoading = isLoadingUser || isLoadingCompanyType || isLoadingAuthUser;

  return (
    <AppContext.Provider value={{ ...appState, setAppState, isLoading }}>
      {children}
    </AppContext.Provider>
  );
};


